import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import logoutImage from '../../images/common/logout.svg';
import { PAGE_PATH } from '../../lib/constants';
import {
  Main,
  MenuWrapper,
  TitleWrapper,
  ButtonsWrapper,
  ButtonWrapper,
  LogoutIconImage,
  style,
} from '../../styles/common/TitleBarStyles';
import { ReactComponent as ServiceLogo } from '../../images/common/logo_OPTiM-taglet.svg';

const DeviceAuthTitleBar = () => (
  <Main>
    <MenuWrapper>
      <TitleWrapper className="button">
        <Link to="/ds/" style={style.linkTitle}>
          <ServiceLogo style={{ width: '150px' }} />
        </Link>
      </TitleWrapper>
    </MenuWrapper>
    <ButtonsWrapper>
      <ButtonWrapper id="logoutButton" role="presentation" className="button">
        <Link to={PAGE_PATH.DS_LOGOUT} style={style.linkLogout}>
          <LogoutIconImage src={logoutImage} alt="logout" />
          <FormattedMessage id="logout.button.name" />
        </Link>
      </ButtonWrapper>
    </ButtonsWrapper>
  </Main>
);

export default DeviceAuthTitleBar;
